/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation MccDeleteMutation($mccId: ID!) {
  MccDelete(mccId: $mccId) {
    id
    message
    status
  }
}
`
